import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './gestures/iosInteractionGuard.css';
import App from './App';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { startConnectivityManager } from './helpers/connectivity';
import { validateAppEnv } from './helpers/validateAppEnv';
import { parseClientViewPath } from './helpers/clientView/clientViewModel';
import { installGlobalErrorReporting } from './monitoring/errorReporter';
import { installRecoveryHashReload } from './helpers/authHelpers';

const envError = validateAppEnv();
const clientViewRoute = parseClientViewPath(window.location.pathname);
const root = ReactDOM.createRoot(document.getElementById('root'));
const workspaceParityRequested =
  process.env.NODE_ENV !== 'production' &&
  new URLSearchParams(window.location.search).get('workspaceParity') === '1';
const financeDesktopRequested =
  process.env.NODE_ENV !== 'production' &&
  new URLSearchParams(window.location.search).get('financeDesktop') === '1';

if (clientViewRoute.isClientView && !envError) {
  // Customer-facing Client View: a separate tiny app (no CrewPilot login, no
  // service worker, no connectivity manager). The link is the permission.
  import('./clientView/ClientViewApp').then(({ ClientViewApp }) => {
    root.render(<ClientViewApp token={clientViewRoute.token} />);
  });
} else if (financeDesktopRequested) {
  import('./dev/FinanceDesktopHarness').then(({ mountFinanceDesktopHarness }) => {
    mountFinanceDesktopHarness(root);
  });
} else if (workspaceParityRequested) {
  import('./dev/WorkspaceParityHarness').then(({ mountWorkspaceParityHarness }) => {
    mountWorkspaceParityHarness(root);
  });
} else if (envError) {
  root.render(
    <div className="app nx-app">
      <div
        style={{
          maxWidth: '560px',
          margin: '48px auto',
          padding: '24px',
          color: '#e8ecf4',
          fontFamily: 'system-ui, sans-serif',
          lineHeight: 1.5,
        }}
      >
        <h1 style={{ fontSize: '22px', marginBottom: '12px' }}>
          Configuration required
        </h1>
        <pre
          style={{
            whiteSpace: 'pre-wrap',
            fontSize: '14px',
            opacity: 0.9,
            margin: 0,
          }}
        >
          {envError}
        </pre>
      </div>
    </div>,
  );
} else {
  startConnectivityManager();
  installGlobalErrorReporting();
  installRecoveryHashReload();

  root.render(
    <React.StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </React.StrictMode>,
  );

  serviceWorkerRegistration.register();
  reportWebVitals();
}

